import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const userManagementSlice = createSlice({
    name: 'userManagementSlice',
    initialState,
    reducers: {
        setAvailableUsersData(store, action) {
            return action.payload;
        },
        resetUsersData() {
            return [];
        },
    },
});

export const { setAvailableUsersData, resetUsersData } =
    userManagementSlice.actions;
export default userManagementSlice.reducer;
